export const uiActionTypes = {
    NAVDRAWER_OPEN: 'NAVDRAWER_OPEN',
    NAVDRAWER_CLOSE: 'NAVDRAWER_CLOSE',
    BUTTON_INDEX: 'BUTON_INDEX'
}